import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Child } from 'src/app/shared/interfaces/child.interface';
import { ChildService } from '../services/child.service';

@Component({
  selector: 'app-children-view',
  templateUrl: './children-view.component.html',
  styleUrls: ['./children-view.component.css'],
})
export class ChildrenViewComponent implements OnInit {
  child: Child;
  constructor(private childService: ChildService, private activeRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activeRoute.params.subscribe((params) => {
      this.getChildById(params.id);
    });
  }

  getChildById(id: number) {
    this.childService.getById(id).then((res: Child) => {
      const { name, birth_date, gender, phone, father_id, mother_id, father_name, mother_name } = res[0];
      const dateFormatted = birth_date.split('T')[0];
      this.child = { name, birth_date: dateFormatted, gender, phone, father_id, mother_id, father_name, mother_name };
    });
  }
}
